import * as React from 'react';
import styled from 'styled-components';
import {Formik, Form as FormContainer} from 'formik';
import {CourseObject} from 'api/course';
import CourseBuilderContext from '../../CourseBuilderContext';
import InputContainer from 'containers/InputContainer';
import {TagBuilder} from 'components/TagBuilder';
import {FolderSelector} from 'components/FolderSelector';
import * as Forms from './forms';
import {Folder, Tag} from 'types';
import {transparentize} from "polished";

const Form = styled(FormContainer)`
  row-gap: 10px;
  display: grid;
`;

const TagsContainer = styled.div`
  margin-bottom: 20px;
`;

const GroupTitle = styled.div`
  position: relative;
  margin-top: 15px;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 400;
  height: 20px;
  color: ${({theme}) => transparentize(.2, theme.variables.color)};
  cursor: default;
`;

/**
 * The builder settings
 * @return {React.ReactElement}
 * @constructor
 */
export default function Settings(): React.ReactElement {
  const {
    course,
    setCourse,
  } = React.useContext(CourseBuilderContext);

  const initialValues: Partial<CourseObject> = {
    ...course,
  };

  /**
   * Render folders.
   * @return {JSX.Element}
   */
  function renderFolders(): JSX.Element {
    /**
     * The change event handler.
     */
    function handleChange(folders: Folder[]): void {
      setCourse && setCourse({
        ...course,
        folders,
      })
    }

    return (
      <TagsContainer>
        <InputContainer label="Папки">
          <FolderSelector
            type="courses"
            folders={course?.folders}
            onChange={handleChange}
            creatable
          />
        </InputContainer>
      </TagsContainer>
    );
  }

  /**
   * Render tags.
   * @return {JSX.Element}
   */
  function renderTags(): JSX.Element {
    /**
     * The change event handler.
     */
    function handleChange(tags: Tag[]): void {
      setCourse && setCourse({
        ...course,
        tags,
      })
    }

    return (
      <TagsContainer>
        <InputContainer label="Теги">
          <TagBuilder
            type="courses"
            tags={course?.tags}
            onChange={handleChange}
          />
        </InputContainer>
      </TagsContainer>
    );
  }

  /**
   * Handle form submit
   * @param {Partial<CourseObject>} settings
   */
  function handleSubmit(settings: Partial<CourseObject>): void {
    setCourse && setCourse({
      ...course,
      ...settings,
    });
  }

  return (
    <React.Fragment>
      {renderFolders()}
      {renderTags()}
      <Formik<Partial<CourseObject>>
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <Forms.GeneralForm />
            <Forms.FixedDateForm />
            <Forms.PostAccessForm />
            <GroupTitle>Бустеры продаж</GroupTitle>
            <Forms.PromocodeForm />
            <Forms.SaleForm />
            <Forms.PostMessageForm />
            <Forms.FreeCoursesForm />
            <Forms.ResaleForm />
            <Forms.FinalLinkForm />
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}
